
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/[id]",
      function () {
        return require("private-next-pages/posts/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/[id]"])
      });
    }
  